import { render } from "./elem-form.vue?vue&type=template&id=7ddf3b7f&ts=true"
import script from "./elem-form.vue?vue&type=script&lang=ts"
export * from "./elem-form.vue?vue&type=script&lang=ts"

import "./elem-form.vue?vue&type=style&index=0&id=7ddf3b7f&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__